import React, { createContext, useState, useContext, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { loadClient, logoutClient } from '../Redux/Actions/ClientActions';

// Créer et exporter le contexte
export const ClientAuthContext = createContext({});

// Hook personnalisé pour utiliser le contexte
export const useClientAuth = () => useContext(ClientAuthContext);

export const ClientAuthProvider = ({ children }) => {
  const dispatch = useDispatch();
  
  const clientState = useSelector(state => state.clientReducer);
  const { client, isAuthenticated, loading } = clientState || {};
  
  const [authChecked, setAuthChecked] = useState(false);

  useEffect(() => {
    const token = localStorage.getItem('clientToken');
    
    if (token && !client) {
      dispatch(loadClient())
        .then(() => setAuthChecked(true))
        .catch(() => setAuthChecked(true));
    } else {
      setAuthChecked(true);
    }
  }, [dispatch, client]);

  const logout = () => {
    dispatch(logoutClient());
  };

  const value = {
    client,
    isAuthenticated: isAuthenticated || false,
    loading: loading || !authChecked,
    logout
  };

  return (
    <ClientAuthContext.Provider value={value}>
      {children}
    </ClientAuthContext.Provider>
  );
};